/**
 * Build Your Bundle page (sections/soi-bundle-builder.liquid).
 *
 * Pieces go straight into the real cart with the hidden line property
 * _bundle = mixmatch, and the right-hand panel is drawn from /cart.js, so what
 * the shopper sees is what Shopify will charge. After every change the page:
 *   1. adds/removes the 3 free gifts exactly like the cart drawer's syncGifts
 *      (same variants, same _gift property), because shoppers skip the drawer;
 *   2. attaches the tier code (BNDL2-5) for the number of _bundle pieces, and
 *      takes it off again below 2 pieces. Other codes already on the cart are
 *      kept as they are.
 * The two checkout buttons repeat the cart drawer's own sequence for Shipping
 * Protection. Nothing in the cart drawer, Kaching or product pricing is touched.
 */
(function () {
  'use strict';

  var D = window.SOIB;
  var root = document.getElementById('soib');
  if (!D || !root) {
    return;
  }

  // Same values as assets/custom-cart-drawer.js and header-secondary-area.liquid.
  var GIFT_VARIANT_IDS = [45485796098095, 44905256452143, 44920460705839];
  var CAPTAIN_VARIANT_ID = 45844643348527;
  var CAPTAIN_PRODUCT_HANDLE = 'shipping-protection-2';
  var COUNT_EXCLUDED_PRODUCT_IDS = [8307911065647, 8160306266159, 8163623731247, 8422701924399];
  var BUNDLE_KEY = '_bundle';
  var BUNDLE_VALUE = 'mixmatch';
  var MAX = 5;
  var PCT = [0, 0, 10, 15, 20, 25];

  var P = (D.products || []).filter(Boolean);
  var BY = {};
  var BY_ID = {};
  P.forEach(function (p) {
    BY[p.h] = p;
    BY_ID[p.id] = p;
  });
  // Tees and sweatpants have no hero yet: borrow the lead message of the
  // hoodie with the same design name (e.g. Sabr Tee -> "Beautiful patience.").
  var LEAD = {};
  P.forEach(function (p) {
    var k = p.n.replace(/ Hoodie( V2)?$/, '').toLowerCase();
    if (p.c === 'h' && p.m && !LEAD[k]) LEAD[k] = p.m;
  });
  function leadOf(p) {
    if (p.m) return p.m;
    var k = p.n.replace(/ (Tees?|Sweatpants)$/i, '').toLowerCase();
    return k === 'signature' || k === 'blank' ? '' : LEAD[k] || '';
  }
  var RATED = (D.rated || []).map(function (h) { return String(h).trim(); });
  var CODES = D.codes || {};
  var CODE_LIST = Object.keys(CODES).map(function (k) { return String(CODES[k] || '').toUpperCase(); }).filter(Boolean);
  var CAT = { h: 'Hoodies', t: 'Tees', s: 'Sweatpants' };
  var CAT1 = { h: 'Hoodie', t: 'Tee', s: 'Sweatpants' };

  var HEX = { Pink: '#e6b3bd', Green: '#3d6b47' };
  String(D.swatches || '').split(/\n/).forEach(function (line) {
    var m = line.match(/^\s*(.+?)\s*:\s*(#[0-9a-fA-F]{3,8})/);
    if (m) {
      HEX[m[1]] = m[2];
    }
  });
  var FAM = [
    ['Black', ['Black', 'Black Beauty'], '#111'],
    // Same colours as Cream, as its own chip for shoppers who look for "White".
    ['White', ['White', 'Lucent White', 'Oat Gray'], '#ffffff'],
    ['Grey', ['Gray', 'Flower Gray', 'Light Gray', 'Carbon Gray'], '#9a9a9e'],
    ['Cream', ['White', 'Lucent White', 'Oat Gray'], '#efece4'],
    ['Green', ['Eden Green', 'Medium Green', 'Gray Green', 'Green', 'Blackish Green'], '#105E3A'],
    ['Blue', ['Medium Blue', 'Navy Blue', 'Gray Blue', 'Jeans Blue'], '#5B7A8A'],
    ['Purple', ['Dark Purple', 'Plum Purple'], '#4A2040'],
    ['Brown', ['Dark Brown', 'Gray Coffee', 'Gray Apricot', 'Gray Camel', 'Brown'], '#6a5650'],
    ['Red & pink', ['Red', 'Pink', 'Brick Red', 'Bean Paste Red'], '#862628']
  ];

  // Find-your-size data: identical to snippets/soi-fit-sheets.liquid.
  var IN_H = ['5′1″', '5′2″', '5′3″', '5′4″', '5′5″', '5′6″', '5′7″', '5′8″', '5′9″', '5′10″', '5′11″', '6′0″', '6′1″', '6′2″', '6′3″', '6′4″'];
  var CM_H = ['155 cm', '157 cm', '160 cm', '163 cm', '165 cm', '168 cm', '170 cm', '173 cm', '175 cm', '178 cm', '180 cm', '183 cm', '185 cm', '188 cm', '191 cm', '193 cm'];
  var IN_W = ['100–129', '130–150', '151–170', '171–185', '186–210', '211–225', '226–250', '251–285'];
  var CM_W = ['45–59', '59–68', '69–77', '78–84', '84–95', '96–102', '103–113', '114–129'];
  var RA = ['S', 'S', 'S', 'S', 'M', 'L', 'XL', '2XL'], RB = ['M', 'M', 'M', 'M', 'M', 'L', 'XL', '2XL'], RC = ['L', 'L', 'L', 'L', 'L', 'L', 'XL', '2XL'];
  var ROWS = [RA, RA, RA, RA, RA, RA, RA, RA, RB, RB, RB, RC, RC, RC, RC, ['XL', 'XL', 'XL', 'XL', 'XL', 'XL', 'XL', '2XL']];
  var ORDER = ['S', 'M', 'L', 'XL', '2XL'];
  // Tee chart (snippets/sizing-guide-tees.liquid): weight only.
  var TEE_LB = ['130–160', '161–190', '191–220', '221–255', '256–290'];
  var W_MID = [115, 140, 160, 178, 198, 218, 238, 268];
  var HOOD_IN = [['S', '27.56', '25.59', '25.98', '21.06'], ['M', '28.35', '26.38', '26.77', '21.46'], ['L', '29.13', '27.17', '27.56', '21.85'], ['XL', '29.92', '27.95', '28.35', '22.24'], ['2XL', '30.71', '28.74', '29.13', '22.64']];
  var HOOD_CM = [['S', '70', '65', '66', '53.5'], ['M', '72', '67', '68', '54.5'], ['L', '74', '69', '70', '55.5'], ['XL', '76', '71', '72', '56.5'], ['2XL', '78', '73', '74', '57.5']];

  var S = { cart: null, cat: 'all', fam: null, q: '', cardCol: {}, mine: null, lastAddedKey: null, busy: false };
  try { S.mine = JSON.parse(localStorage.getItem('soib-size') || 'null'); } catch (e) {}

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function logError(ctx, err) { console.error('[soi-bundle-builder] ' + ctx, err); }
  function pct(n) { return PCT[Math.min(n, MAX)]; }
  function inFam(name, fam) { for (var i = 0; i < FAM.length; i++) if (FAM[i][0] === fam) return FAM[i][1].indexOf(String(name).trim()) > -1; return false; }
  function hexOf(name) { return HEX[String(name).trim()] || '#cccccc'; }
  function meta(p) { var n = p.cols.length; return [p.s, n + (n === 1 ? ' colour' : ' colours')].filter(Boolean).join(' · '); }
  function img(url, w) { if (!url) return ''; return url.replace(/([?&])width=\d+/, '$1width=' + w); }

  function currency() { return (S.cart && S.cart.currency) || D.currency || 'CAD'; }
  // Shopify's own money format for the shopper's currency (sample rendered by
  // Liquid's money filter), so prices read exactly like the cart drawer.
  var fmt = (function (sample) {
    var m = String(sample || '').match(/1([^0-9]?)234([^0-9])56/);
    if (!m) return null;
    var pre = sample.slice(0, m.index), post = sample.slice(m.index + m[0].length), th = m[1], dec = m[2];
    return function (cents) {
      var neg = cents < 0, v = Math.abs(Math.round(cents));
      var whole = String(Math.floor(v / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return (neg ? '-' : '') + pre + whole + dec + ('0' + (v % 100)).slice(-2) + post;
    };
  })(D.moneySample);
  function money(cents) {
    if (fmt && currency() === D.currency) return fmt(cents);
    try {
      return new Intl.NumberFormat(D.locale || undefined, { style: 'currency', currency: currency() }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------- Cart API ---------------- */
  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) {
          var e = new Error(j && (j.description || j.message) || 'Cart error');
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }

  function isBundleLine(item) { return !!(item.properties && item.properties[BUNDLE_KEY] === BUNDLE_VALUE); }
  function isGiftLine(item) { return GIFT_VARIANT_IDS.indexOf(item.variant_id) > -1; }
  function isProtectionLine(item) { return item.variant_id === CAPTAIN_VARIANT_ID; }
  function bundleCount(cart) {
    return (cart ? cart.items : []).reduce(function (a, i) { return a + (isBundleLine(i) ? i.quantity : 0); }, 0);
  }
  function qualifyingIds() {
    var ids = window.CCD_QUALIFYING_PRODUCT_IDS;
    if (ids && ids.length) return ids;
    return P.filter(function (p) { return p.c !== 's'; }).map(function (p) { return p.id; });
  }

  // Mirrors syncGifts() in custom-cart-drawer.js.
  function syncGifts(cart) {
    var q = qualifyingIds();
    var hasQualifying = cart.items.some(function (i) { return q.indexOf(i.product_id) > -1; });
    var present = cart.items.filter(isGiftLine).map(function (i) { return i.variant_id; });
    if (hasQualifying && present.length < GIFT_VARIANT_IDS.length) {
      var missing = GIFT_VARIANT_IDS.filter(function (id) { return present.indexOf(id) === -1; });
      return post('/cart/add.js', { items: missing.map(function (id) { return { id: id, quantity: 1, properties: { _gift: 'true' } }; }) }).then(fetchCart);
    }
    if (!hasQualifying && present.length) {
      var updates = {};
      present.forEach(function (id) { updates[id] = 0; });
      return post('/cart/update.js', { updates: updates });
    }
    return Promise.resolve(cart);
  }

  function cartCodes(cart) {
    return (cart.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); }).filter(Boolean);
  }
  // Attaches the code for the current tier; removes BNDL codes below 2 pieces.
  function syncCode(cart) {
    var n = bundleCount(cart);
    var want = n >= 2 ? String(CODES[Math.min(n, MAX)] || '').toUpperCase() : '';
    var have = cartCodes(cart);
    var others = have.filter(function (c) { return CODE_LIST.indexOf(c) === -1; });
    var haveBundle = have.filter(function (c) { return CODE_LIST.indexOf(c) > -1; });
    var ok = want ? haveBundle.length === 1 && haveBundle[0] === want : haveBundle.length === 0;
    if (ok) return Promise.resolve(cart);
    var next = (want ? [want] : []).concat(others);
    return post('/cart/update.js', { discount: next.join(',') });
  }

  // Lines + quantities + codes: tells whether the cart really changed.
  function cartSig(cart) {
    return cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|') + '#' + cartCodes(cart).join(',');
  }
  var lastSig = null;
  // notify: tell the cart drawer to redraw. Always after our own add/remove;
  // otherwise only when the gift/code sync itself changed the cart, so the
  // drawer watcher below can't start a refresh loop.
  function afterChange(cart, notify) {
    var before = cartSig(cart);
    return syncGifts(cart)
      .then(syncCode)
      .then(function (c) {
        S.cart = c;
        lastSig = cartSig(c);
        if (notify || lastSig !== before) document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateHeaderCount(c);
        return c;
      });
  }
  function ours(cart) { return afterChange(cart, true); }
  function theirs(cart) { return afterChange(cart, false); }

  var queue = Promise.resolve();
  function run(fn) {
    var next = queue.then(function () {
      setBusy(true);
      return fn();
    }).then(function (c) {
      setBusy(false);
      renderAll();
      return c;
    }, function (err) {
      setBusy(false);
      logError('cart', err);
      return fetchCart().then(function (c) { S.cart = c; renderAll(); }).catch(function () {}).then(function () { throw err; });
    });
    queue = next.catch(function () {});
    return next;
  }
  function setBusy(b) {
    S.busy = b;
    $$('[data-sb-cartbox]', document).forEach(function (el) { el.classList.toggle('is-busy', b); });
  }

  function updateHeaderCount(cart) {
    try {
      var n = cart.items.reduce(function (a, i) { return a + (COUNT_EXCLUDED_PRODUCT_IDS.indexOf(i.product_id) > -1 ? 0 : i.quantity); }, 0);
      document.querySelectorAll('.thb-item-count').forEach(function (el) { el.textContent = n > 99 ? '99+' : String(n); });
    } catch (e) {}
  }

  function addPiece(variantId) {
    return run(function () {
      return post('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _bundle: BUNDLE_VALUE } }] })
        .then(function (res) { S.lastAddedKey = res.items && res.items[0] && res.items[0].key; })
        .then(fetchCart)
        .then(ours);
    });
  }
  function changeLine(key, qty) {
    return run(function () {
      return post('/cart/change.js', { id: key, quantity: qty }).then(ours);
    });
  }

  /* Checkout: the cart drawer's exact Shipping Protection sequence. */
  function removeProtection() {
    var updates = {};
    updates[CAPTAIN_VARIANT_ID] = 0;
    return post('/cart/update.js', { updates: updates });
  }
  function addProtection() {
    return post('/cart/add.js', { items: [{ id: CAPTAIN_VARIANT_ID, quantity: 1 }] });
  }
  function checkout(withProtection, btn) {
    $$('[data-sb-protected],[data-sb-without],[data-sb-checkout]', document).forEach(function (b) { b.disabled = true; });
    queue
      .then(fetchCart)
      .then(theirs)
      .then(removeProtection)
      .then(function () { return withProtection ? addProtection() : null; })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        logError(withProtection ? 'protected checkout' : 'checkout without protection', err);
        window.location.href = '/checkout';
      });
  }
  var protectionPrice = null;
  function loadProtectionPrice() {
    fetch('/products/' + CAPTAIN_PRODUCT_HANDLE + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.id === CAPTAIN_VARIANT_ID; })[0];
        if (v) {
          protectionPrice = v.price;
          $$('[data-sb-protection-price]', document).forEach(function (el) { el.textContent = '+' + money(protectionPrice); });
        }
      })
      .catch(function (err) { logError('protection price', err); });
  }

  /* ---------------- Rendering ---------------- */
  function nextNote(n) {
    if (n === 0) return 'Add 2 pieces to start saving.';
    if (n === 1) return 'Add 1 more for <b>10% off</b>.';
    if (n >= MAX) return '<b>25% off unlocked.</b> That’s the best price.';
    return '<b>' + pct(n) + '% off unlocked.</b> Add 1 more for ' + pct(n + 1) + '% off.';
  }
  function renderLadder() {
    var n = bundleCount(S.cart), h = '';
    for (var k = 1; k <= MAX; k++) {
      h += '<div class="sb-rung' + (n >= k && k > 1 ? ' is-hit' : '') + (Math.min(n, MAX) === k ? ' is-now' : '') + '"><span class="sb-rung__n">' + k + (k === 1 ? ' piece' : ' pieces') + '</span><span class="sb-rung__p' + (k === 1 ? ' sb-rung__p--full' : '') + '">' + (k === 1 ? 'Full price' : PCT[k] + '% off') + '</span></div>';
    }
    $('[data-sb-ladder]').innerHTML = h;
    // Under 5 pieces the note is an action pill (pulsing + badge, bouncing
    // arrow) that scrolls to the products; at 5 it's a calm "unlocked" line.
    $('[data-sb-ladder-note]').innerHTML = n >= MAX
      ? '<span class="sb-nudge sb-nudge--done"><span class="sb-nudge__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><span>' + nextNote(n) + '</span></span>'
      : '<button type="button" class="sb-nudge" data-sb-browse><span class="sb-nudge__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#0f1b33" stroke-width="3" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg></span><span class="sb-nudge__t">' + nextNote(n) + '</span><span class="sb-nudge__arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v13M6 13l6 6 6-6"/></svg></span></button>';
  }

  function visible() {
    var q = S.q.trim().toLowerCase();
    return P.filter(function (p) {
      if (S.cat !== 'all' && p.c !== S.cat) return false;
      if (S.fam && !p.cols.some(function (c) { return inFam(c[0], S.fam); })) return false;
      if (q && (p.n + ' ' + p.s + ' ' + CAT[p.c]).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
  }
  function renderSeg() {
    var cnt = { all: P.length, h: 0, t: 0, s: 0 };
    P.forEach(function (p) { cnt[p.c]++; });
    $('[data-sb-seg]').innerHTML = [['all', 'All'], ['h', 'Hoodies'], ['t', 'Tees'], ['s', 'Sweatpants']].map(function (x) {
      return '<button type="button" role="tab" aria-selected="' + (S.cat === x[0]) + '" class="' + (S.cat === x[0] ? 'is-on' : '') + '" data-sb-cat="' + x[0] + '">' + x[1] + '<span>' + cnt[x[0]] + '</span></button>';
    }).join('');
  }
  function renderChips() {
    $('[data-sb-chips]').innerHTML = '<button type="button" class="sb-chip sb-chip--any' + (!S.fam ? ' is-on' : '') + '" data-sb-fam="">Any colour</button>' + FAM.map(function (f) {
      return '<button type="button" class="sb-chip' + (S.fam === f[0] ? ' is-on' : '') + '" data-sb-fam="' + esc(f[0]) + '"><i style="background:' + f[2] + '"></i>' + esc(f[0]) + '</button>';
    }).join('');
  }
  function cardColour(p) {
    if (S.cardCol[p.h] != null) return S.cardCol[p.h];
    if (S.fam) for (var i = 0; i < p.cols.length; i++) if (inFam(p.cols[i][0], S.fam)) return i;
    return 0;
  }
  function inBundle(p) {
    return (S.cart ? S.cart.items : []).reduce(function (a, i) { return a + (isBundleLine(i) && i.product_id === p.id ? i.quantity : 0); }, 0);
  }
  function cardHTML(p) {
    var ci = cardColour(p), n = inBundle(p), show = p.cols.length > 7 ? 6 : p.cols.length;
    var sw = p.cols.slice(0, show).map(function (c, i) {
      return '<button type="button" class="sb-sw' + (i === ci ? ' is-on' : '') + '" style="background:' + hexOf(c[0]) + '" data-sb-sw="' + esc(p.h) + '" data-ci="' + i + '" aria-label="' + esc(c[0]) + '" title="' + esc(c[0]) + '"></button>';
    }).join('');
    if (p.cols.length > show) sw += '<button type="button" class="sb-sw-more" data-sb-open="' + esc(p.h) + '">+' + (p.cols.length - show) + '</button>';
    return '<article class="sb-card" data-sb-card="' + esc(p.h) + '">' +
      '<div class="sb-card__media" data-sb-open="' + esc(p.h) + '" role="button" tabindex="0" aria-label="Choose ' + esc(p.n) + '">' +
        galleryHTML(p.cols[ci][1], 520, p.n + ', ' + p.cols[ci][0]) +
        (p.b ? '<span class="sb-badge sb-badge--' + esc(p.b.split(' ')[0]) + '">' + esc(p.b) + '</span>' : '') +
        inbHTML(n) +
        '<span class="sb-card__add" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>' +
      '</div>' +
      '<div class="sb-card__sw">' + sw + '</div>' +
      '<p class="sb-card__name">' + esc(p.n) + '</p>' +
      (RATED.indexOf(p.h) > -1 ? '<p class="sb-card__rating"><span aria-hidden="true">\u2605</span> 4.9/5 \u00B7 10,000+ sold</p>' : '') +
      '<p class="sb-card__meta">' + esc(meta(p)) + '</p>' +
      '<p class="sb-card__price">' + money(p.p) + '</p>' +
    '</article>';
  }
  function renderGrid() {
    var v = visible();
    $('[data-sb-count]').textContent = v.length + (v.length === 1 ? ' design' : ' designs') + (S.cat === 'all' ? '' : ' in ' + CAT[S.cat]) + (S.fam ? ' · ' + S.fam : '');
    $('[data-sb-grid]').innerHTML = v.length ? v.map(cardHTML).join('') : '<div class="sb-empty">No designs match that search.<br><button type="button" data-sb-reset>Show everything</button></div>';
  }
  // Every photo of one colour as a swipeable strip, with page dots and (on
  // devices with a mouse) arrows. Only the first photo loads up front.
  function galleryHTML(urls, w, alt) {
    var many = urls.length > 1;
    return '<div class="sb-track" data-sb-track>' + urls.map(function (u, k) {
        return '<img src="' + esc(img(u, w)) + '" alt="' + (k ? '' : esc(alt)) + '" loading="lazy" width="390" height="520" draggable="false">';
      }).join('') + '</div>' +
      (many ? '<div class="sb-gdots" data-sb-dots aria-hidden="true">' + urls.map(function (u, k) { return '<span class="' + (k ? '' : 'is-on') + '"></span>'; }).join('') + '</div>' +
        '<button type="button" class="sb-gnav sb-gnav--prev" data-sb-nav="-1" aria-label="Previous photo"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="sb-gnav sb-gnav--next" data-sb-nav="1" aria-label="Next photo"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' : '');
  }
  function inbHTML(n) {
    return n ? '<span class="sb-inb"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' + (n > 1 ? n + ' in bundle' : 'In bundle') + '</span>' : '';
  }
  // After a tab / colour change, start the new list from its first row: if the
  // shopper had scrolled into the products, jump back to where the grid begins
  // (just under the sticky search + tabs bar). Above the grid, nothing moves.
  function toGridTop() {
    var anchor = sentinel || $('[data-sb-bar]');
    if (!anchor) return;
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - header;
    if (window.pageYOffset > top + 1) window.scrollTo(0, top);
  }
  function refreshCard(h) {
    var el = root.querySelector('[data-sb-card="' + h + '"]'), p = BY[h];
    if (!el || !p) return;
    var t = document.createElement('div');
    t.innerHTML = cardHTML(p);
    el.replaceWith(t.firstChild);
  }
  // Cart changes only touch the "In bundle" badges, so photos keep their place.
  function updateBadges() {
    $$('[data-sb-card]').forEach(function (el) {
      var p = BY[el.getAttribute('data-sb-card')];
      if (!p) return;
      var media = el.querySelector('.sb-card__media'), old = media.querySelector('.sb-inb'), html = inbHTML(inBundle(p));
      if (old) old.remove();
      if (html) media.insertAdjacentHTML('beforeend', html);
    });
  }
  function onTrackScroll(e) {
    var tr = e.target;
    if (!tr || !tr.matches || !tr.matches('[data-sb-track]')) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    var dots = tr.parentNode.querySelector('[data-sb-dots]');
    if (!dots) return;
    Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
  }

  var ICON_X = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#6e6e73" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function lineName(item) { var p = BY_ID[item.product_id]; return p ? p.n : item.product_title; }
  function lineVariant(item) {
    return (item.options_with_values || []).map(function (o) { return o.value; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' · ');
  }
  function lineImg(item) {
    var u = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  function slotHTML(item, unitIndex) {
    var orig = item.original_price, fin = item.final_price;
    return '<div class="sb-slot' + (item.key === S.lastAddedKey && unitIndex === item.quantity - 1 ? ' is-new' : '') + '">' +
      '<div class="sb-slot__img">' + (lineImg(item) ? '<img src="' + esc(lineImg(item)) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="sb-slot__txt"><p class="sb-slot__n">' + esc(lineName(item)) + '</p><p class="sb-slot__v">' + esc(lineVariant(item)) + '</p></div>' +
      '<span class="sb-slot__p">' + (fin < orig ? '<s>' + money(orig) + '</s>' : '') + money(fin) + '</span>' +
      '<button type="button" class="sb-slot__x" data-sb-rm="' + esc(item.key) + '" data-qty="' + item.quantity + '" aria-label="Remove ' + esc(lineName(item)) + '">' + ICON_X + '</button></div>';
  }

  function totals(cart) {
    var t = { sub: 0, disc: 0, n: bundleCount(cart), gifts: 0, others: [], bundle: [] };
    (cart ? cart.items : []).forEach(function (i) {
      if (isGiftLine(i)) { t.gifts += i.quantity; return; }
      if (isProtectionLine(i)) return;
      t.sub += i.original_line_price;
      t.disc += i.original_line_price - i.final_line_price;
      (isBundleLine(i) ? t.bundle : t.others).push(i);
    });
    t.total = t.sub - t.disc;
    var codes = cart ? cartCodes(cart) : [];
    t.code = codes.filter(function (c) { return CODE_LIST.indexOf(c) > -1; })[0] || '';
    t.pc = t.code ? pct(t.n) : 0;
    return t;
  }

  function bundleHTML() {
    var cart = S.cart, t = totals(cart), h = '', n = t.n;
    h += '<div class="sb-bx" data-sb-cartbox>';
    h += '<div class="sb-bx__head"><p class="sb-bx__t">Your bundle</p><span class="sb-bx__c">' + Math.min(n, MAX) + ' of 5</span></div>';
    h += '<div class="sb-meter">' + [1, 2, 3, 4, 5].map(function (k) { return '<span class="' + (n >= k ? 'is-on' : '') + '"></span>'; }).join('') + '</div>';
    h += '<div class="sb-meter-l"><span>' + n + (n === 1 ? ' piece' : ' pieces') + '</span>' + (pct(n) ? '<b>' + pct(n) + '% off</b>' : '<span>' + (n ? 'Add 1 more for 10% off' : 'Up to 25% off') + '</span>') + '</div>';
    h += '<div class="sb-slots">';
    t.bundle.forEach(function (item) {
      for (var u = 0; u < item.quantity; u++) h += slotHTML(item, u);
    });
    for (var k = n + 1; k <= MAX; k++) {
      h += '<button type="button" class="sb-slot sb-slot--empty" data-sb-browse><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#86868b" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>Piece ' + k + (k > 1 ? ' · <b>' + PCT[k] + '% off</b>' : '') + '</button>';
    }
    h += '</div>';
    if (t.others.length) {
      h += '<p class="sb-also">Also in your cart</p><div class="sb-slots" style="margin-top:10px">';
      t.others.forEach(function (item) {
        h += '<div class="sb-slot"><div class="sb-slot__img">' + (lineImg(item) ? '<img src="' + esc(lineImg(item)) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="sb-slot__txt"><p class="sb-slot__n">' + (item.quantity > 1 ? item.quantity + ' × ' : '') + esc(lineName(item)) + '</p><p class="sb-slot__v">' + esc(lineVariant(item)) + '</p></div>' +
          '<span class="sb-slot__p">' + (item.final_line_price < item.original_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '') + money(item.final_line_price) + '</span>' +
          '<button type="button" class="sb-slot__x" data-sb-rm="' + esc(item.key) + '" data-qty="1" data-all="1" aria-label="Remove ' + esc(lineName(item)) + '">' + ICON_X + '</button></div>';
      });
      h += '</div>';
    }
    h += '<div class="sb-tot">';
    h += '<div class="sb-tot__r"><span>Subtotal</span><span>' + money(t.sub) + '</span></div>';
    if (t.disc > 0) h += '<div class="sb-tot__r sb-tot__r--g"><span>' + (t.code && !t.others.length ? 'Bundle discount (' + t.pc + '%)' : 'Discounts') + '</span><span>−' + money(t.disc) + '</span></div>';
    h += '<div class="sb-tot__r sb-tot__r--g"><span>Shipping</span><span>Free</span></div>';
    h += '<div class="sb-tot__r sb-tot__r--t"><span>Total</span><span>' + money(t.total) + '</span></div>';
    h += '</div>';
    if (t.gifts) h += '<div class="sb-gift"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#c9a45c" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1.5"/><path d="M3 12h18M12 8v13"/><path d="M12 8S10.5 3.5 7.8 4.2C5.6 4.8 6.6 8 12 8zM12 8s1.5-4.5 4.2-3.8C18.4 4.8 17.4 8 12 8z"/></svg><p><b>' + t.gifts + ' free gift' + (t.gifts === 1 ? '' : 's') + ' included</b> <span>· E-books, instant download</span></p></div>';
    if (t.disc > 0) h += '<p class="sb-rating" style="margin-top:12px"><span class="sb-saved">You save ' + money(t.disc) + '</span></p>';
    var empty = !(t.bundle.length || t.others.length);
    h += '<p class="sb-rating"><span aria-hidden="true">★★★★★</span> Rated 4.9/5 by 650+ verified reviews</p>';
    h += '<button type="button" class="sb-protected" data-sb-protected' + (empty ? ' disabled' : '') + '>Protected Checkout &mdash; <span data-sb-protection-price>' + (protectionPrice != null ? '+' + money(protectionPrice) : '+$3.00') + '</span></button>';
    h += '<button type="button" class="sb-without" data-sb-without' + (empty ? ' disabled' : '') + '>Checkout without package protection</button>';
    if (empty) h += '<p class="sb-bx__empty">Add a piece to start your bundle.</p>';
    h += '</div>';
    return h;
  }
  function wfHTML() {
    var I = {
      ship: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
      fit: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M8.5 12l2.5 2.5 4.5-5"/>',
      ret: '<path d="M20 11a8 8 0 0 0-14.5-4.5L4 8"/><path d="M4 4v4h4"/><path d="M4 13a8 8 0 0 0 14.5 4.5L20 16"/><path d="M20 20v-4h-4"/>',
      heart: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/>'
    };
    return [['ship', 'Free shipping', 'Tracked to your door'], ['fit', 'Fit Guarantee', 'Doesn’t fit? We exchange it.'], ['ret', 'Easy returns', 'Exchange or credit'], ['heart', '10% to charity', 'From every order']].map(function (x) {
      return '<div class="sb-wf__i"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + I[x[0]] + '</svg><span><span class="sb-wf__t">' + x[1] + '</span><span class="sb-wf__s">' + x[2] + '</span></span></div>';
    }).join('');
  }
  function wfCard() { return '<div class="sb-wf"><h3 class="sb-wf__h">Every order. <span>Worry-free.</span></h3><div class="sb-wf__card">' + wfHTML() + '</div></div>'; }

  function renderPanel() {
    $('[data-sb-panel]').innerHTML = bundleHTML() + wfCard();
    var t = totals(S.cart), n = t.n, has = !!(t.bundle.length || t.others.length);
    var units = [], thumbs = '';
    t.bundle.forEach(function (i) { for (var u = 0; u < i.quantity; u++) units.push(i); });
    for (var k = 0; k < MAX; k++) {
      var it = units[k];
      thumbs += it && lineImg(it) ? '<span class="sb-mb__th"><img src="' + esc(lineImg(it)) + '" alt=""></span>' : '<span class="sb-mb__th is-empty"></span>';
    }
    var nudge = n >= MAX ? '<b>Best price unlocked</b> \u00B7 25% off every piece'
      : n ? 'Add 1 more \u2192 <b>' + pct(n + 1) + '% off</b> your whole bundle'
      : 'Pick 2 pieces \u2192 <b>10% off</b>, up to 25% for 5';
    mbarEl.innerHTML = '<div class="sb-mb">' +
      '<div class="sb-mb__top"><p class="sb-mb__t">' + (n ? Math.min(n, MAX) + ' of 5' + (pct(n) ? ' \u00B7 <b>' + pct(n) + '% off</b>' : '') : 'Build your bundle') + '</p>' +
        (t.disc > 0 ? '<p class="sb-mb__save">You save ' + money(t.disc) + '</p>' : '') + '</div>' +
      '<div class="sb-mb__meter">' + [1, 2, 3, 4, 5].map(function (k) { return '<span class="' + (n >= k ? 'is-on' : '') + '"></span>'; }).join('') + '</div>' +
      '<div class="sb-mb__row"><button type="button" class="sb-mb__thumbs" data-sb-bundle-open aria-label="Review your bundle">' + thumbs +
        '<span class="sb-mb__up" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg></span></button>' +
        '<button type="button" class="sb-mb__btn" data-sb-checkout' + (has ? '' : ' disabled') + '><span>' + (has ? 'Checkout' : 'Add a piece') + '</span>' + (has ? '<small>' + money(t.total) + '</small>' : '') + '</button></div>' +
      '<p class="sb-mb__nudge">' + nudge + '</p>' +
    '</div>';
    if (sheetKind === 'bundle') openBundle(true);
  }
  function renderAll() {
    renderLadder();
    renderPanel();
    updateBadges();
  }

  /* ---------------- Sheets ---------------- */
  // Two stacked layers. Layer 0 holds the product, bundle, guarantee or quiz;
  // layer 1 holds the size quiz when it's opened from inside a product, so
  // closing it lands back on that same product. Both live on <body> so the
  // theme's sticky header and transforms can't clip them.
  var toastEl = $('[data-sb-toast]');
  document.body.appendChild(toastEl);
  toastEl.classList.add('soib');
  var mbarEl = $('[data-sb-mbar]');
  var baseSheet = $('[data-sb-sheet]');
  var layers = [baseSheet, baseSheet.cloneNode(true)].map(function (el, i) {
    document.body.appendChild(el);
    el.classList.add('soib');
    el.setAttribute('data-sb-layer', String(i));
    if (i) el.style.zIndex = '2147483001';
    return { el: el, p: el.querySelector('[data-sb-sheet-p]'), kind: null, opener: null, closeT: 0 };
  });
  var sheetKind = null;
  var sheetP = layers[0].p;
  function layerOf(node) { var s2 = node && node.closest && node.closest('[data-sb-layer]'); return s2 ? +s2.getAttribute('data-sb-layer') : 0; }
  function anyOpen() { return layers.some(function (L) { return !L.el.hidden; }); }

  function openSheet(kind, html, cls, keep, li) {
    li = li || 0;
    var L = layers[li];
    clearTimeout(L.closeT);
    if (!keep) L.opener = document.activeElement;
    L.kind = kind;
    if (!li) sheetKind = kind;
    L.p.className = 'sb-sheet__p' + (cls ? ' ' + cls : '');
    L.p.style.transform = '';
    L.p.innerHTML = '<div class="sb-sheet__grab"><span></span></div><button type="button" class="sb-sheet__x" data-sb-close aria-label="Close"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6e6e73" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' + html;
    if (L.el.hidden) {
      L.el.hidden = false;
      document.body.classList.add('sb-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { L.el.classList.add('is-open'); }); });
    }
    if (!keep) L.p.focus({ preventScroll: true });
  }
  function closeSheet(li) {
    if (li == null) li = layers[1].el.hidden ? 0 : 1;
    var L = layers[li];
    if (L.el.hidden) return;
    L.el.classList.remove('is-open');
    L.kind = null;
    if (!li) sheetKind = null;
    L.closeT = setTimeout(function () {
      L.el.hidden = true;
      L.p.innerHTML = '';
      L.p.style.transform = '';
      if (!anyOpen()) document.body.classList.remove('sb-lock');
      if (L.opener && L.opener.focus && document.contains(L.opener)) L.opener.focus({ preventScroll: true });
    }, 380);
  }

  // Pull down on the handle / top strip, or on the content when it's scrolled
  // to the top, to close (phones; on desktop the popup is a centred modal).
  function bindDrag(L, li) {
    var p = L.p, sy = 0, sx = 0, dy = 0, t0 = 0, mode = null, fromHead = false, atTop = false;
    p.addEventListener('touchstart', function (e) {
      mode = null;
      if (window.innerWidth >= 760 || e.touches.length !== 1) return;
      var t = e.touches[0], body = p.querySelector('.sb-sheet__body');
      sy = t.clientY; sx = t.clientX; dy = 0; t0 = Date.now();
      fromHead = t.clientY - p.getBoundingClientRect().top < 56;
      atTop = !body || body.scrollTop <= 0;
      mode = 'wait';
    }, { passive: true });
    p.addEventListener('touchmove', function (e) {
      if (!mode || mode === 'no') return;
      var t = e.touches[0], ddy = t.clientY - sy, ddx = t.clientX - sx;
      if (mode === 'wait') {
        if (Math.abs(ddy) < 6 && Math.abs(ddx) < 6) return;
        mode = ddy > 0 && Math.abs(ddy) > Math.abs(ddx) && (fromHead || atTop) ? 'drag' : 'no';
        if (mode !== 'drag') return;
        p.style.transition = 'none';
      }
      dy = Math.max(0, ddy);
      p.style.transform = 'translateY(' + dy + 'px)';
      e.preventDefault();
    }, { passive: false });
    function end() {
      if (mode === 'drag') {
        var v = dy / Math.max(1, Date.now() - t0);
        p.style.transition = '';
        if (dy > 110 || (dy > 40 && v > 0.6)) {
          p.style.transform = 'translateY(105%)';
          closeSheet(li);
        } else {
          p.style.transform = '';
        }
      }
      mode = null;
    }
    p.addEventListener('touchend', end);
    p.addEventListener('touchcancel', end);
  }
  layers.forEach(bindDrag);

  var pd = null;
  function mineFor(p) {
    if (!S.mine) return null;
    var s = p.c === 'h' ? S.mine.h : p.c === 't' ? S.mine.t : null;
    var i = s ? p.sz.indexOf(s) : -1;
    return i > -1 ? i : null;
  }
  function openProduct(h, ci) {
    var p = BY[h];
    if (!p) return;
    pd = { h: h, ci: ci != null ? ci : cardColour(p), si: mineFor(p) };
    var v = pd.si != null && p.v[pd.ci + '-' + pd.si];
    if (pd.si != null && !(v && v[1])) pd.si = null;
    renderProduct(false);
  }
  function renderProduct(keep) {
    var p = BY[pd.h], n = bundleCount(S.cart), full = n >= MAX, m = mineFor(p);
    var after = Math.min(n + 1, MAX), gain = pct(after);
    var guide;
    if (p.c === 'h') guide = '<p class="sb-fitnote"><b>Oversized fit.</b> Between sizes? Size down.' + (m != null ? ' <span class="sb-mine">● Your size from the quiz</span>' : '') + '</p>';
    else if (p.c === 't') guide = '<p class="sb-fitnote"><b>Relaxed fit.</b> Size by weight. Between sizes? Size down.' + (m != null ? ' <span class="sb-mine">● Your size from the quiz</span>' : '') + '</p><div class="sb-teeg">' + ORDER.map(function (s, i) { return '<div><b>' + s + '</b>' + TEE_LB[i] + ' lb</div>'; }).join('') + '</div>';
    else guide = '<p class="sb-fitnote"><b>Relaxed fit, unisex sizing.</b> Between sizes? Size down.</p>';
    var html = '<div class="sb-sheet__body"><div class="sb-pd">' +
      '<div class="sb-pd__media"><div class="sb-pd__img">' + galleryHTML(p.cols[pd.ci][1], 900, p.n + ', ' + p.cols[pd.ci][0]) + '</div></div>' +
      '<div class="sb-pd__info">' +
        '<div>' + (leadOf(p) || p.s ? '<p class="sb-pd__eyebrow">' + esc([leadOf(p), p.s].filter(Boolean).join(' · ')) + '</p>' : '') + '<h2 class="sb-pd__name">' + esc(p.n) + '</h2>' +
        '<p class="sb-pd__rating"><span aria-hidden="true">\u2605</span> 4.9/5 \u00B7 650+ reviews \u00B7 10,000+ sold</p>' +
        '<p class="sb-pd__price">' + money(p.p) + (gain && !full ? '<small>' + gain + '% off as piece ' + after + '</small>' : '') + '</p></div>' +
        '<div><p class="sb-opt__l">Colour <span>' + esc(p.cols[pd.ci][0]) + '</span></p><div class="sb-sws">' + p.cols.map(function (c, i) { return '<button type="button" class="sb-sw' + (i === pd.ci ? ' is-on' : '') + '" style="background:' + hexOf(c[0]) + '" data-sb-pci="' + i + '" aria-label="' + esc(c[0]) + '" aria-pressed="' + (i === pd.ci) + '"></button>'; }).join('') + '</div></div>' +
        '<div><p class="sb-opt__l">Size' + (p.c === 's' ? '' : '<button type="button" class="sb-link" data-sb-fit-open>' + (S.mine ? 'Retake size quiz' : 'Find my size') + '</button>') + '</p><div class="sb-sizes">' + p.sz.map(function (s, i) { var v = p.v[pd.ci + '-' + i]; var ok = v && v[1]; return '<button type="button" class="sb-size' + (i === pd.si ? ' is-on' : '') + (i === m ? ' is-mine' : '') + '" data-sb-psi="' + i + '"' + (ok ? '' : ' disabled') + ' aria-pressed="' + (i === pd.si) + '">' + esc(s) + '</button>'; }).join('') + '</div>' + guide + '</div>' +
        '<div class="sb-pfg"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0b6e64" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg><div><p class="sb-pfg__t">Perfect Fit Guarantee</p><p class="sb-pfg__s">If your size isn’t a perfect fit, we’ll exchange it. No questions asked.</p></div></div>' +
      '</div></div></div>' +
      '<div class="sb-sheet__foot"><button type="button" class="sb-cta" data-sb-padd' + (full || pd.si == null || S.busy ? ' disabled' : '') + '>' + (full ? 'Your bundle is full' : pd.si == null ? 'Select a size' : 'Add to bundle') + '</button>' +
      '<p class="sb-foot-note">' + (full ? 'Remove a piece to swap this one in.' : 'This will be piece ' + after + ' of 5' + (gain ? ' · <b>' + gain + '% off</b> the whole bundle' : '') + '.') + '</p></div>';
    var body = keep && sheetP.querySelector('.sb-sheet__body'), st = body ? body.scrollTop : 0;
    var tr = keep && sheetP.querySelector('.sb-pd [data-sb-track]'), gx = tr && pd.galCi === pd.ci ? tr.scrollLeft : 0;
    openSheet('product', html, 'sb-sheet__p--media', keep, 0);
    pd.galCi = pd.ci;
    if (keep) {
      var nb = sheetP.querySelector('.sb-sheet__body'); if (nb) nb.scrollTop = st;
      var nt = sheetP.querySelector('.sb-pd [data-sb-track]'); if (nt && gx) { nt.scrollLeft = gx; onTrackScroll({ target: nt }); }
    }
  }
  function openBundle(keep) {
    var body = keep && sheetP.querySelector('.sb-sheet__body'), st = body ? body.scrollTop : 0;
    openSheet('bundle', '<div class="sb-sheet__body"><div class="sb-bs">' + bundleHTML() + wfCard() + '</div></div>', 'sb-sheet__p--band sb-sheet__p--sm', keep);
    if (keep) { var nb = sheetP.querySelector('.sb-sheet__body'); if (nb) nb.scrollTop = st; }
  }

  var fit = { unit: 'in', h: 8, w: 2, shift: 0, step: 0, chart: false }, fitLayer = 0;
  function pinnedSmall(h, w) { return (h <= 5 && w <= 2) || (h >= 6 && h <= 7 && w <= 1); }
  function shiftSize(s, k) { return ORDER[Math.min(ORDER.length - 1, Math.max(0, ORDER.indexOf(s) + k))]; }
  function fitResult() {
    var pin = pinnedSmall(fit.h, fit.w), hs = shiftSize(ROWS[fit.h][fit.w], pin ? 0 : fit.shift);
    var lb = W_MID[fit.w], ti = lb <= 160 ? 0 : lb <= 190 ? 1 : lb <= 220 ? 2 : lb <= 255 ? 3 : 4;
    return { h: hs, t: ORDER[Math.min(4, ti + (fit.shift && !pin ? 1 : 0))], pin: pin };
  }
  function renderFit(keep) {
    var hs = fit.unit === 'in' ? IN_H : CM_H, ws = fit.unit === 'in' ? IN_W : CM_W, wu = fit.unit === 'in' ? ' lb' : ' kg';
    var chev = '<svg width="10" height="14" viewBox="0 0 10 16" fill="none" stroke="#0b6e64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 5l3-3 3 3M2 11l3 3 3-3"/></svg>';
    var body;
    if (fit.chart) {
      var rows = fit.unit === 'in' ? HOOD_IN : HOOD_CM, me = fit.step === 2 ? fitResult().h : null;
      body = '<div><p class="sb-fs__k">Hoodie measurements</p><h2 class="sb-fs__h">Measure it yourself.</h2><p class="sb-fs__lede">Lay a hoodie you love flat and compare. All sizes are unisex.</p></div>' +
        '<div class="sb-fs__seg"><button type="button" class="' + (fit.unit === 'in' ? 'is-on' : '') + '" data-sb-unit="in">Inches</button><button type="button" class="' + (fit.unit === 'cm' ? 'is-on' : '') + '" data-sb-unit="cm">Centimeters</button></div>' +
        '<table class="sb-chart"><thead><tr><th>Size</th><th>Length</th><th>Shoulder</th><th>Chest</th><th>Sleeve</th></tr></thead><tbody>' + rows.map(function (r) { return '<tr class="' + (r[0] === me ? 'is-me' : '') + '">' + r.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table>' +
        '<p class="sb-fs__note"><b>Between sizes? Size down.</b> Measurements can vary by 1–3 cm.</p><button type="button" class="sb-fs__link" data-sb-fchart="0">‹ Back to the quiz</button>';
    } else if (fit.step === 0) {
      body = '<div class="sb-fs__prog"><span class="is-on"></span><span></span></div><div><p class="sb-fs__k">Step 1 of 2</p><h2 class="sb-fs__h">Let’s find your size.</h2><p class="sb-fs__lede">Two quick questions. About ten seconds.</p></div>' +
        '<div class="sb-fs__seg"><button type="button" class="' + (fit.unit === 'in' ? 'is-on' : '') + '" data-sb-unit="in">in · lb</button><button type="button" class="' + (fit.unit === 'cm' ? 'is-on' : '') + '" data-sb-unit="cm">cm · kg</button></div>' +
        '<div class="sb-fs__list"><label class="sb-fs__row"><span>Height</span><span class="sb-fs__val">' + hs[fit.h] + chev + '</span><select data-sb-fh aria-label="Height">' + hs.map(function (x, i) { return '<option value="' + i + '"' + (i === fit.h ? ' selected' : '') + '>' + x + '</option>'; }).join('') + '</select></label>' +
        '<label class="sb-fs__row"><span>Weight</span><span class="sb-fs__val">' + ws[fit.w] + wu + chev + '</span><select data-sb-fw aria-label="Weight">' + ws.map(function (x, i) { return '<option value="' + i + '"' + (i === fit.w ? ' selected' : '') + '>' + x + wu + '</option>'; }).join('') + '</select></label></div>' +
        '<button type="button" class="sb-fs__cta" data-sb-fstep="1">Continue</button><button type="button" class="sb-fs__link" data-sb-fchart="1">Prefer exact measurements? View size chart ›</button>';
    } else if (fit.step === 1) {
      body = '<div class="sb-fs__prog"><span class="is-on"></span><span class="is-on"></span></div><div><p class="sb-fs__k">Step 2 of 2</p><h2 class="sb-fs__h">How do you like it to fit?</h2><p class="sb-fs__lede">Every hoodie is already cut oversized.</p></div>' +
        '<div class="sb-fs__cards">' + [[0, 'Standard', 'Relaxed and oversized, the way it’s designed.', 1], [1, 'Extra oversized', 'Roomier, with more drape. One size up.', 0]].map(function (c) { return '<button type="button" class="sb-fs__card' + (fit.shift === c[0] ? ' is-on' : '') + '" data-sb-fshift="' + c[0] + '"><div><p class="sb-fs__ct">' + c[1] + (c[3] ? '<em>Recommended</em>' : '') + '</p><p class="sb-fs__cs">' + c[2] + '</p></div><span class="sb-fs__radio"></span></button>'; }).join('') + '</div>' +
        '<button type="button" class="sb-fs__cta" data-sb-fstep="2">See my size</button>';
    } else {
      var r = fitResult();
      body = '<div><p class="sb-fs__k">Your size</p><h2 class="sb-fs__h">Here’s your fit.</h2><p class="sb-fs__lede">' + hs[fit.h] + ' · ' + ws[fit.w] + wu + ' · ' + (fit.shift && !r.pin ? 'Extra oversized' : 'Standard') + '</p></div>' +
        '<div class="sb-fs__res"><div class="sb-fs__rc"><span class="sb-fs__rl">Hoodies</span><span class="sb-fs__rs">' + r.h + '</span><span class="sb-fs__rb">' + (r.pin ? 'Small in either fit' : 'Oversized cut') + '</span></div><div class="sb-fs__rc"><span class="sb-fs__rl">Tees</span><span class="sb-fs__rs">' + r.t + '</span><span class="sb-fs__rb">From our tee chart</span></div></div>' +
        '<button type="button" class="sb-fs__cta" data-sb-fuse>Use these sizes in my bundle</button>' +
        '<p class="sb-fs__note">We’ll pre-select them on every hoodie and tee. You can change any piece.<br><b>Backed by our Perfect Fit Guarantee.</b></p>' +
        '<button type="button" class="sb-fs__link" data-sb-fstep="0">Start over</button>';
    }
    openSheet('fit', '<div class="sb-sheet__body"><div class="sb-fs">' + body + '</div></div>', 'sb-sheet__p--band sb-sheet__p--sm', keep, fitLayer);
  }
  function openPfg() {
    openSheet('pfg', '<div class="sb-sheet__body"><div class="sb-pfgsheet"><svg width="44" height="44" viewBox="0 0 24 24" fill="#ffffff" stroke="#0b6e64" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg><h2>Our Perfect Fit Guarantee</h2><p>Shop with confidence. If your size is not a perfect fit, we will exchange it, no questions asked.</p><p>It covers every piece in your bundle.</p><button type="button" class="sb-fs__cta" style="max-width:340px;margin-top:8px" data-sb-fit-open>Find my size</button><button type="button" class="sb-fs__link" data-sb-close>Done</button></div></div>', 'sb-sheet__p--sm');
  }
  function openWorryFree() {
    openSheet('wf', '<div class="sb-sheet__body"><div class="sb-bs">' + wfCard() +
      '<div class="sb-pfg"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0b6e64" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg><div><p class="sb-pfg__t">Perfect Fit Guarantee</p><p class="sb-pfg__s">If your size isn\u2019t a perfect fit, we\u2019ll exchange it. No questions asked. It covers every piece in your bundle.</p></div></div>' +
      '<button type="button" class="sb-fs__cta" data-sb-fit-open>Find my size</button></div></div>', 'sb-sheet__p--band sb-sheet__p--sm');
  }
  function renderFitTile() {
    if (!S.mine) return;
    $('[data-sb-fit-tile-t]').textContent = 'Your size: hoodies ' + S.mine.h + ', tees ' + S.mine.t + '.';
    $('[data-sb-fit-tile-s]').innerHTML = 'Change &rsaquo;';
  }

  var toastT = 0;
  function toast(html, err) {
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-err', !!err);
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* ---------------- Events ---------------- */
  function onClick(e) {
    var t = e.target, el;
    if (!t.closest) return;
    if ((el = t.closest('[data-sb-cat]'))) { S.cat = el.getAttribute('data-sb-cat'); renderSeg(); renderGrid(); toGridTop(); return; }
    if ((el = t.closest('[data-sb-fam]'))) { var f = el.getAttribute('data-sb-fam') || null; S.fam = S.fam === f ? null : f; S.cardCol = {}; renderChips(); renderGrid(); toGridTop(); return; }
    if (t.closest('[data-sb-reset]')) { S.cat = 'all'; S.fam = null; S.q = ''; $('[data-sb-q]').value = ''; renderSeg(); renderChips(); renderGrid(); toGridTop(); return; }
    if ((el = t.closest('[data-sb-nav]'))) {
      var trk = el.parentNode.querySelector('[data-sb-track]');
      if (trk) trk.scrollBy({ left: +el.getAttribute('data-sb-nav') * trk.clientWidth, behavior: 'smooth' });
      return;
    }
    if ((el = t.closest('[data-sb-sw]'))) { var sh = el.getAttribute('data-sb-sw'); S.cardCol[sh] = +el.getAttribute('data-ci'); refreshCard(sh); return; }
    if ((el = t.closest('[data-sb-open]'))) { openProduct(el.getAttribute('data-sb-open')); return; }
    if ((el = t.closest('[data-sb-pci]'))) { pd.ci = +el.getAttribute('data-sb-pci'); var v = BY[pd.h].v[pd.ci + '-' + pd.si]; if (pd.si != null && !(v && v[1])) pd.si = null; renderProduct(true); return; }
    if ((el = t.closest('[data-sb-psi]'))) { pd.si = +el.getAttribute('data-sb-psi'); renderProduct(true); return; }
    if ((el = t.closest('[data-sb-padd]'))) {
      if (bundleCount(S.cart) >= MAX || pd.si == null || S.busy) return;
      var p = BY[pd.h], variant = p.v[pd.ci + '-' + pd.si];
      if (!variant) return;
      el.disabled = true;
      var before = pct(bundleCount(S.cart));
      S.cardCol[pd.h] = pd.ci;
      closeSheet();
      addPiece(variant[0]).then(function (c) {
        var n = bundleCount(c), now = pct(n);
        toast(now > before ? '<b>' + now + '% off unlocked</b> ' + (n < MAX ? '· add 1 more for ' + pct(n + 1) + '%' : '· bundle complete') : 'Added ' + esc(p.n) + (n < MAX ? ' · add 1 more for 10% off' : ''));
        S.lastAddedKey = null;
      }).catch(function (err) {
        toast(err && err.status === 422 ? 'That size just sold out. Try another.' : 'Couldn’t add that piece. Please try again.', true);
      });
      return;
    }
    if ((el = t.closest('[data-sb-rm]'))) {
      if (S.busy) return;
      var qty = +el.getAttribute('data-qty');
      changeLine(el.getAttribute('data-sb-rm'), el.hasAttribute('data-all') ? 0 : Math.max(qty - 1, 0)).catch(function () { toast('Couldn’t update your cart. Please try again.', true); });
      return;
    }
    if (t.closest('[data-sb-browse]')) {
      var wasOpen = !!sheetKind;
      if (wasOpen) closeSheet();
      setTimeout(function () { $('[data-sb-bar]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }, wasOpen ? 300 : 0);
      return;
    }
    if (t.closest('[data-sb-bundle-open]')) { openBundle(false); return; }
    if ((el = t.closest('[data-sb-checkout]'))) { if (!el.disabled) checkout(true, el); return; }
    if ((el = t.closest('[data-sb-protected]'))) { checkout(true, el); return; }
    if ((el = t.closest('[data-sb-without]'))) { checkout(false, el); return; }
    if (t.closest('[data-sb-fit-open]')) {
      fit.step = 0; fit.chart = false;
      fitLayer = sheetKind === 'product' ? 1 : 0;
      renderFit(fitLayer === 0 && !!sheetKind);
      return;
    }
    if (t.closest('[data-sb-pfg-open]')) { openPfg(); return; }
    if (t.closest('[data-sb-wf-open]')) { openWorryFree(); return; }
    if ((el = t.closest('[data-sb-unit]'))) { fit.unit = el.getAttribute('data-sb-unit'); renderFit(true); return; }
    if ((el = t.closest('[data-sb-fstep]'))) { fit.step = +el.getAttribute('data-sb-fstep'); renderFit(true); return; }
    if ((el = t.closest('[data-sb-fshift]'))) { fit.shift = +el.getAttribute('data-sb-fshift'); renderFit(true); return; }
    if ((el = t.closest('[data-sb-fchart]'))) { fit.chart = el.getAttribute('data-sb-fchart') === '1'; renderFit(true); return; }
    if (t.closest('[data-sb-fuse]')) {
      var r = fitResult();
      S.mine = { h: r.h, t: r.t };
      try { localStorage.setItem('soib-size', JSON.stringify(S.mine)); } catch (err) {}
      renderFitTile();
      if (fitLayer === 1 && sheetKind === 'product' && pd) {
        closeSheet(1);
        var fp = BY[pd.h], fm = mineFor(fp), fv = fm != null && fp.v[pd.ci + '-' + fm];
        if (fv && fv[1]) pd.si = fm;
        renderProduct(true);
      } else {
        closeSheet(0);
      }
      toast('Sizes saved · hoodies <b>' + r.h + '</b>, tees <b>' + r.t + '</b>');
      return;
    }
    if ((el = t.closest('[data-sb-close]'))) { closeSheet(layerOf(el)); return; }
  }
  root.addEventListener('click', onClick);
  root.addEventListener('scroll', onTrackScroll, true);
  root.addEventListener('keydown', function (e) {
    var el = e.target;
    if ((e.key === 'Enter' || e.key === ' ') && el.matches && el.matches('.sb-card__media[data-sb-open]')) { e.preventDefault(); openProduct(el.getAttribute('data-sb-open')); }
  });
  layers.forEach(function (L) {
    L.el.addEventListener('click', onClick);
    L.el.addEventListener('scroll', onTrackScroll, true);
    L.el.addEventListener('change', function (e) {
      if (e.target.matches('[data-sb-fh]')) { fit.h = +e.target.value; renderFit(true); }
      if (e.target.matches('[data-sb-fw]')) { fit.w = +e.target.value; renderFit(true); }
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  var qT = 0;
  $('[data-sb-q]').addEventListener('input', function (e) { clearTimeout(qT); qT = setTimeout(function () { S.q = e.target.value; renderGrid(); }, 120); });
  var bar = $('[data-sb-bar]'), sentinel = null;
  if ('IntersectionObserver' in window) {
    sentinel = document.createElement('div');
    bar.parentNode.insertBefore(sentinel, bar);
    new IntersectionObserver(function (en) { bar.classList.toggle('is-stuck', !en[0].isIntersecting); }).observe(sentinel);
  }
  // Slide the phone bar away while the theme's mobile menu is open, so the
  // menu's bottom links (account, login) aren't covered. Only watches the
  // menu's own open/active state; nothing in the header is changed.
  var menuToggle = document.querySelector('.mobile-toggle-wrapper');
  if (menuToggle && 'MutationObserver' in window) {
    var syncMenu = function () { document.body.classList.toggle('sb-menu-open', menuToggle.hasAttribute('open') || menuToggle.classList.contains('active')); };
    new MutationObserver(syncMenu).observe(menuToggle, { attributes: true, attributeFilter: ['open', 'class'] });
    syncMenu();
  }
  // The phone bar is fixed; keep it out of the theme's transformed wrappers too.
  document.body.appendChild(mbarEl);
  mbarEl.classList.add('soib');
  document.body.classList.add('sb-has-mbar');
  mbarEl.addEventListener('click', onClick);

  // Hero photos: advance every 5 s; swipe (touch), drag (mouse) or tap a dot
  // to change, which restarts the timer.
  (function () {
    var hero = root.querySelector('.sb-photohero');
    if (!hero) return;
    var imgs = hero.querySelectorAll('.sb-photohero__bg img'), dots = hero.querySelectorAll('[data-sb-hero-dot]');
    if (imgs.length < 2) return;
    var idx = 0, timer = 0, still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      idx = (i + imgs.length) % imgs.length;
      Array.prototype.forEach.call(imgs, function (im, k) { im.classList.toggle('is-on', k === idx); });
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-on', k === idx); d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
    }
    function restart() { clearInterval(timer); if (!still) timer = setInterval(function () { if (!document.hidden) go(idx + 1); }, 5000); }
    hero.classList.add('is-js');
    go(0);
    restart();
    hero.addEventListener('click', function (e) {
      var d = e.target.closest && e.target.closest('[data-sb-hero-dot]');
      if (d) { go(+d.getAttribute('data-sb-hero-dot')); restart(); }
    });
    var sx = null, sy = 0;
    hero.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; sx = e.clientX; sy = e.clientY; });
    hero.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { go(idx + (dx < 0 ? 1 : -1)); restart(); }
    });
    hero.addEventListener('pointercancel', function () { sx = null; });
  })();

  $$('[data-sb-wf]').forEach(function (el) { el.innerHTML = wfHTML(); });
  renderSeg();
  renderChips();
  renderGrid();
  renderLadder();
  renderPanel();
  renderFitTile();
  loadProtectionPrice();
  // Sync on load too: corrects the code/gifts if the cart changed elsewhere.
  run(function () { return fetchCart().then(theirs); }).catch(function () {});

  // Changes made elsewhere (the cart drawer's remove / + / -, another tab,
  // coming back from checkout): re-read the real cart, then fix the gifts,
  // the tier code, the panel and the header count. Read-only towards the
  // drawer: it only watches the drawer's content being redrawn.
  var extT = 0;
  function externalCheck() {
    clearTimeout(extT);
    extT = setTimeout(function () {
      if (S.busy) return;
      fetchCart().then(function (c) {
        if (lastSig !== null && cartSig(c) === lastSig) return;
        return run(function () { return theirs(c); });
      }).catch(function (err) { logError('external cart change', err); });
    }, 350);
  }
  var drawerContent = document.getElementById('CustomCartDrawerContent');
  if (drawerContent && 'MutationObserver' in window) {
    new MutationObserver(externalCheck).observe(drawerContent, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') externalCheck(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) externalCheck(); });
})();
